import {database} from "./firebase.js";
import { userModel } from "./index.js";
import {Howl} from 'howler';

class UserModel {
    /** Model containing information for the logged in user from firebase*/
    constructor(answers = [], time = 0, currentTask = 0, currentTaskIndex = 0){
        this.id = Math.round(Math.random() * 100000);
        this.secondTest = false;
        this.speechGender = null;
        this.instructions = [
            [{instructionF: "/task1F.mp3", instructionM: "/task1M.mp3", correctAnswer: "greenSquare", answer: "", timeInstr: 0, last: false, repeatCounter: 0}, 
            {instruction: "", correctAnswer: "greenSquare", answer: "", timeInstr: 0, last: false},
            {instruction: "", correctAnswer: "redSquare", answer: "", timeInstr: 0, last: true}],

            [{instructionF: "/task2F.mp3", instructionM: "/task2M.mp3", correctAnswer: "redCircle", answer: "red", timeInstr: 0, last: false, repeatCounter: 0}, 
            {instructionF: "", correctAnswer: "yellowSquare", answer: "", timeInstr: 0, last: true}],

            [{instructionF: "/task3F.mp3", instructionM: "/task3M.mp3", correctAnswer: "pinkSquare", answer: "", timeInstr: 0, last: false, repeatCounter: 0}, 
            {instruction: "", correctAnswer: "pinkSquare", answer: "", timeInstr: 0, last: false},
            {instruction: "", correctAnswer: "blackCircle", answer: "", timeInstr: 0, last: true}],

            [{instructionF: "/task4F.mp3", instructionM: "/task4M.mp3", correctAnswer: "Circle", correctAnswerCategory: "anyCircle", answer: "", timeInstr: 0, last: false, repeatCounter: 0},
            {instruction: "", correctAnswer: "", correctAnswerCategory: "anySquare", answer: "", timeInstr: 0, last: false}, 
            {instruction: "", correctAnswer: "whiteCircle", answer: "", timeInstr: 0, last: true}],

            [{instructionF: "/task5F.mp3", instructionM: "/task5M.mp3", correctAnswer: "greenSquare", answer: "", timeInstr: 0, last: false, repeatCounter: 0},
            {instruction: "", correctAnswer: "pinkSquare", answer: "", timeInstr: 0, last: true}],

            [{instructionF: "/task6F.mp3", instructionM: "/task6M.mp3", correctAnswer: "purpleSquare", answer: "", timeInstr: 0, last: false, repeatCounter: 0},
            {instruction: "", correctAnswer: "pinkSquare", answer: "", timeInstr: 0, last: true}],

            [{instructionF: "/task7F.mp3", instructionM: "/task7M.mp3", correctAnswer: "whiteCircle", correctAnswerCategory: "", answer: "", timeInstr: 0, last: false, repeatCounter: 0},
            {instruction: "", correctAnswer: "whiteCircle", correctAnswerCategory: "", answer: "", timeInstr: 0, last: false}, 
            {instruction: "", correctAnswer: "purpleSquare", answer: "", timeInstr: 0, last: true}],

            [{instructionF: "/task8F.mp3", instructionM: "/task8M.mp3", correctAnswerCategory: "CircleSquare", correctAnswer: "blue", answer: "", timeInstr: 0, last: false, repeatCounter: 0},
            {instruction: "", correctAnswerCategory: "", correctAnswer: "purpleSquare", answer: "", timeInstr: 0, last: true}],

            [{instructionF: "/task9F.mp3", instructionM: "/task9M.mp3", correctAnswer: "blueSquare", correctAnswerCategory: "", answer: "", timeInstr: 0, last: false, repeatCounter: 0},
            {instruction: "", correctAnswer: "purpleSquare", correctAnswerCategory: "", answer: "", timeInstr: 0, last: false}, 
            {instruction: "", correctAnswer: "yellowSquare", answer: "", timeInstr: 0, last: true}],

            [{instructionF: "/task10F.mp3", instructionM: "/task10M.mp3", correctAnswer: "blueCircle", correctAnswerCategory: "", answer: "", timeInstr: 0, last: false, repeatCounter: 0},
            {instruction: "", correctAnswer: "blueCircle", correctAnswerCategory: "", answer: "", timeInstr: 0, last: false}, 
            {instruction: "", correctAnswer: "blueSquare", answer: "", timeInstr: 0, last: true}],

            [{instructionF: "/task11F.mp3", instructionM: "/task11M.mp3", correctAnswer: "blackCircle", correctAnswerCategory: "", answer: "", timeInstr: 0, last: false, repeatCounter: 0},
            {instruction: "", correctAnswer: "blackSquare", correctAnswerCategory: "", answer: "", timeInstr: 0, last: false}, 
            {instruction: "", correctAnswer: "redCircle", answer: "", timeInstr: 0, last: true}],

            [{instructionF: "/task12F.mp3", instructionM: "/task12M.mp3", correctAnswer: "pinkSquare", correctAnswerCategory: "", answer: "", timeInstr: 0, last: false, repeatCounter: 0},
            {instruction: "", correctAnswer: "blackCircle", answer: "", timeInstr: 0, last: true}],

            [{instructionF: "/task13F.mp3", instructionM: "/task13M.mp3", correctAnswer: "redSquare", correctAnswerCategory: "", answer: "", timeInstr: 0, last: false, repeatCounter: 0},
            {instruction: "", correctAnswer: "greenCircle", answer: "", timeInstr: 0, last: true}],

            [{instructionF: "/task14F.mp3", instructionM: "/task14M.mp3", correctAnswer: "blueCircle", correctAnswerCategory: "", answer: "", timeInstr: 0, last: false, repeatCounter: 0},
            {instruction: "", correctAnswer: "purpleSquare", answer: "", timeInstr: 0, last: true}],

            [{instructionF: "/task15F.mp3", instructionM: "/task15M.mp3", correctAnswerCategory: "CircleSquare", correctAnswer: "green", answer: "", timeInstr: 0, last: false, repeatCounter: 0},
            {instruction: "", correctAnswer: "", correctAnswerCategory: "anySquare", answer: "", timeInstr: 0, last: false},
            {instruction: "", correctAnswerCategory: "", correctAnswer: "blueCircle", answer: "", timeInstr: 0, last: true}],

            [{instructionF: "/task16F.mp3", instructionM: "/task16M.mp3", correctAnswer: "whiteSquare", correctAnswerCategory: "", answer: "", timeInstr: 0, last: false, repeatCounter: 0},
            {instruction: "", correctAnswer: "whiteCircle", answer: "", timeInstr: 0, last: true}],

            [{instructionF: "/task17F.mp3", instructionM: "/task17M.mp3", correctAnswer: "greenCircle", correctAnswerCategory: "", answer: "", timeInstr: 0, last: false, repeatCounter: 0},
            {instruction: "", correctAnswer: "whiteCircle", answer: "", timeInstr: 0, last: true}],

            [{instructionF: "/task18F.mp3", instructionM: "/task18M.mp3", correctAnswer: "", correctAnswerCategory: "anySquare", answer: "", timeInstr: 0, last: false, repeatCounter: 0},
            {instruction: "", correctAnswer: "yellowCircle", correctAnswerCategory: "", answer: "", timeInstr: 0, last: false}, 
            {instruction: "", correctAnswer: "purpleCircle", answer: "", timeInstr: 0, last: true}],

            [{instructionF: "/task19F.mp3", instructionM: "/task19M.mp3", correctAnswer: "redSquare", correctAnswerCategory: "", answer: "", timeInstr: 0, last: false, repeatCounter: 0},
            {instruction: "", correctAnswer: "redSquare", correctAnswerCategory: "", answer: "", timeInstr: 0, last: false}, 
            {instruction: "", correctAnswer: "blackSquare", answer: "", timeInstr: 0, last: true}],

            [{instructionF: "/task20F.mp3", instructionM: "/task20M.mp3", correctAnswer: "greenSquare", correctAnswerCategory: "", answer: "", timeInstr: 0, last: false, repeatCounter: 0},
            {instruction: "", correctAnswer: "blueSquare", answer: "", timeInstr: 0, last: true}],

            [{instructionF: "/task21F.mp3", instructionM: "/task21M.mp3", correctAnswerCategory: "CircleSquare", correctAnswer: "yellow", answer: "", timeInstr: 0, last: false, repeatCounter: 0},
            {instruction: "", correctAnswer: "yellow", correctAnswerCategory: "CircleSquare", answer: "", timeInstr: 0, last: false},
            {instruction: "", correctAnswerCategory: "", correctAnswer: "purpleCircle", answer: "", timeInstr: 0, last: true}],

            [{instructionF: "/task22F.mp3", instructionM: "/task22M.mp3", correctAnswer: "", correctAnswerCategory: "anyButton", answer: "", timeInstr: 0, last: false, repeatCounter: 0},
            {instruction: "", correctAnswerCategory: "", correctAnswer: "redCircle", answer: "", timeInstr: 0, last: true}],

            [{instructionF: "/task23F.mp3", instructionM: "/task23M.mp3", correctAnswer: "redSquare", correctAnswerCategory: "", answer: "", timeInstr: 0, last: false, repeatCounter: 0},
            {instruction: "", correctAnswer: "blueSquare", answer: "", timeInstr: 0, last: true}],

            [{instructionF: "/task24F.mp3", instructionM: "/task24M.mp3", correctAnswer: "pinkSquare", correctAnswerCategory: "", answer: "", timeInstr: 0, last: false, repeatCounter: 0},
            {instruction: "", correctAnswer: "purpleCircle", answer: "", timeInstr: 0, last: true}],

            [{instructionF: "/task25F.mp3", instructionM: "/task25M.mp3", correctAnswer: "redCircle", correctAnswerCategory: "", answer: "", timeInstr: 0, last: false, repeatCounter: 0},
            {instruction: "", correctAnswer: "blueCircle", answer: "", timeInstr: 0, last: true}],
            
            [{instructionF: "/task26F.mp3", instructionM: "/task26M.mp3", correctAnswer: "purpleSquare", correctAnswerCategory: "", answer: "", timeInstr: 0, last: false, repeatCounter: 0},
            {instruction: "", correctAnswer: "yellowSquare", correctAnswerCategory: "", answer: "", timeInstr: 0, last: false},
            {instruction: "", correctAnswer: "blackSquare", answer: "", timeInstr: 0, last: true}],

            [{instructionF: "/task27F.mp3", instructionM: "/task27M.mp3", correctAnswer: "greenSquare", correctAnswerCategory: "", answer: "", timeInstr: 0, last: false, repeatCounter: 0},
            {instruction: "", correctAnswer: "blackCircle", answer: "", timeInstr: 0, last: true}],

            [{instructionF: "/task28F.mp3", instructionM: "/task28M.mp3", correctAnswer: "yellowCircle", correctAnswerCategory: "", answer: "", timeInstr: 0, last: false, repeatCounter: 0},
            {instruction: "", correctAnswer: "yellowCircle", correctAnswerCategory: "", answer: "", timeInstr: 0, last: false},
            {instruction: "", correctAnswer: "redSquare", answer: "", timeInstr: 0, last: true}],

            [{instructionF: "/task29F.mp3", instructionM: "/task29M.mp3", correctAnswer: "purpleSquare", correctAnswerCategory: "", answer: "", timeInstr: 0, last: false, repeatCounter: 0},
            {instruction: "", correctAnswer: "blueCircle", correctAnswerCategory: "", answer: "", timeInstr: 0, last: false},
            {instruction: "", correctAnswer: "redSquare", answer: "", timeInstr: 0, last: true}],

            [{instructionF: "/task30F.mp3", instructionM: "/task30M.mp3", correctAnswer: "greenSquare", correctAnswerCategory: "", answer: "", timeInstr: 0, last: false, repeatCounter: 0},
            {instruction: "", correctAnswer: "whiteSquare", answer: "", timeInstr: 0, last: true}],
            
        ];
        this.time = time;
        this.currentTask = currentTask;
        this.currentTaskIndex = currentTaskIndex;
        this.subscribers = [];
        this.instrTime = 0;
        this.start = false;
        this.nextQuestion = false;
        this.showRepeat = false;
        this.headPhones = null;
    }
    
    addObserver(obs){
        this.subscribers= this.subscribers.concat(obs); 
        return ()=> this.removeObserver(obs);                                                   
    }

    removeObserver(obs){
        this.subscribers= this.subscribers.filter(o=> o!== obs); 
    }

    notifyObservers(){
        this.subscribers.forEach(callback=> {
            try{callback()}catch(err){
                  console.error("Error ", err, callback);}
        })
    }

    setAnswer(answer) {
        if (this.instructions[this.currentTask][this.currentTaskIndex].correctAnswerCategory === "anyCircle" && answer.includes("Circle")) {
            this.instructions[this.currentTask][this.currentTaskIndex].answer = answer;
            this.instructions[this.currentTask][this.currentTaskIndex].timeInstr = this.instrTime;
            if (this.instructions[this.currentTask][this.currentTaskIndex].last) {
                this.currentTask += 1;
                this.currentTaskIndex = 0;
                this.showRepeat = false;
                this.nextQuestion = true;
            }
            else {
                this.currentTaskIndex += 1;
            }
            this.instrTime = 0;
            //console.log(this.instructions[this.currentTask][this.currentTaskIndex]);
            this.notifyObservers();
            return;
        }

        if (this.instructions[this.currentTask][this.currentTaskIndex].correctAnswerCategory === "anyButton") {
            this.instructions[this.currentTask][this.currentTaskIndex].answer = answer;
            this.instructions[this.currentTask][this.currentTaskIndex].timeInstr = this.instrTime;
            if (this.instructions[this.currentTask][this.currentTaskIndex].last) {
                this.currentTask += 1;
                this.currentTaskIndex = 0;
                this.showRepeat = false;
                this.nextQuestion = true;
            }
            else {
                this.currentTaskIndex += 1;
            }
            this.instrTime = 0;
            //console.log(this.instructions[this.currentTask][this.currentTaskIndex]);
            this.notifyObservers();
            return;
        }

        if (this.instructions[this.currentTask][this.currentTaskIndex].correctAnswerCategory === "anySquare" && answer.includes("Square")) {
            this.instructions[this.currentTask][this.currentTaskIndex].answer = answer;
            this.instructions[this.currentTask][this.currentTaskIndex].timeInstr = this.instrTime;
            if (this.instructions[this.currentTask][this.currentTaskIndex].last) {
                this.currentTask += 1;
                this.currentTaskIndex = 0;
                this.showRepeat = false;
                this.nextQuestion = true;
            }
            else {
                this.currentTaskIndex += 1;
            }
            this.instrTime = 0;
            //console.log(this.instructions[this.currentTask][this.currentTaskIndex]);
            this.notifyObservers();
            return;
        }
        //console.log(this.instructions[this.currentTask][this.currentTaskIndex]);
        if (this.instructions[this.currentTask][this.currentTaskIndex].correctAnswerCategory === "CircleSquare" && answer.includes(this.instructions[this.currentTask][this.currentTaskIndex].correctAnswer)) {
            this.instructions[this.currentTask][this.currentTaskIndex].answer = answer;
            this.instructions[this.currentTask][this.currentTaskIndex].timeInstr = this.instrTime;

            if (this.instructions[this.currentTask][this.currentTaskIndex].last) {
                this.currentTask += 1;
                this.currentTaskIndex = 0;
                this.showRepeat = false;
                this.nextQuestion = true;
            }
            else {
                this.currentTaskIndex += 1;
            }
            this.instrTime = 0;
            //console.log(this.instructions[this.currentTask][this.currentTaskIndex]);
            return;
        }

        if (answer !== this.instructions[this.currentTask][this.currentTaskIndex].correctAnswer) return;
        
        this.instructions[this.currentTask][this.currentTaskIndex].answer = answer;
        this.instructions[this.currentTask][this.currentTaskIndex].timeInstr = this.instrTime;
        if (this.instructions[this.currentTask][this.currentTaskIndex].last) {
            this.currentTask += 1;
            this.currentTaskIndex = 0;
            this.showRepeat = false;
            this.nextQuestion = true;
        }
        else {
            this.currentTaskIndex += 1;
        }
        this.instrTime = 0;
        this.notifyObservers();
    }

    setGender() {
        database.ref('genderCounter/counter').once('value', (snapshot) => {
            let data = snapshot.val();
            //console.log(data);
            if (data % 2 === 0) {
                this.speechGender = "m";
            }
            else {
                this.speechGender = "f";
            }
            database.ref('genderCounter').set({
                counter: data += 1
            })
            userModel.start = true;
            userModel.showRepeat = true;
            userModel.playInstruction();
            this.notifyObservers();
            //userModel.uploadInfoFB();
          });
    }

    getTime() {
        this.time = this.time + 0.01;
        return Math.round(this.time * 10) / 10;
    }

    setHeadPhones(headphones) {
        this.headphones = headphones;
    }

    shuffleInstructions() {
        for (let i = this.instructions.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * i)
            const temp = this.instructions[i]
            this.instructions[i] = this.instructions[j]
            this.instructions[j] = temp
        }
    }

    setInstrTime() {
        this.instrTime += 0.01;
    }
    
    uploadInfoFB() {
        database.ref('testSubjects/').push().set({
            id: this.id,
            lastGender: this.speechGender,
            instructions: this.instructions
          });
    }

    playInstruction() {
        if (this.currentTask === userModel.instructions.length/2) {
            if (this.speechGender === "m") {
                this.speechGender = "f"
            } else {
                this.speechGender = "m";
            }
        }

        if (this.speechGender === "m") {
            var soundM = new Howl({
                src: [userModel.instructions[userModel.currentTask][0].instructionM]
              });
            soundM.play();
        } else {
            var soundF = new Howl({
                src: [userModel.instructions[userModel.currentTask][0].instructionF]
            })
            soundF.play();
        }
    }

    playInstructionRepeat() {
        //console.log("speechgender i repeat", this.speechGender);
        if (this.speechGender === "m") {
            var soundM = new Howl({
                src: [userModel.instructions[userModel.currentTask][0].instructionM]
              });
            soundM.play();
        } else {
            var soundF = new Howl({
                src: [userModel.instructions[userModel.currentTask][0].instructionF]
            })
            soundF.play();
        }
    }
}

export {UserModel};